<template>
  <div>
    <div class="form-group required">
      <label class="control-label">Correct option</label>
      <div class="form-group required">
        <el-select v-model="inputs.correct_options" v-validate="'required'" name="correct_options"
                   placeholder="select correct option" style="width: 100%;">
          <el-option
            v-for="item in [{value: 'true', label: 'True'}, {value: 'false', label: 'False'}]"
            :key="item.value" v-bind:class="{'has-error' : errors.has('correct_options')}"
            :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div class="help text-danger" v-show="errors.has('correct_options')">
          {{ errors.first("correct_options") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrueFalseFields',
  props: {
    inputs: {
      type: Object,
      default: {},
    }
  },
  inject: {
    $validator: '$validator'
  },
  computed: {
    //
  }
}
</script>
